import { render, staticRenderFns } from "./CreatePromoCodeModal.vue?vue&type=template&id=6c22f572&scoped=true"
import script from "./CreatePromoCodeModal.vue?vue&type=script&lang=js"
export * from "./CreatePromoCodeModal.vue?vue&type=script&lang=js"
import style0 from "./CreatePromoCodeModal.vue?vue&type=style&index=0&id=6c22f572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c22f572",
  null
  
)

export default component.exports